/*
 * @Author: Dong
 * @Date: 2022-04-25 17:24:23
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-01 16:31:59
 */
import React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './index.less';
import empty from 'root/assets/images/illustrator_empty2.png';

const NoPackaeg = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img src={empty} className={styles.emptyImg} />
      <span className={styles.tip1}>{intl.formatMessage(messages.noInstall)}</span>
    </div>
  );
};

export default NoPackaeg;
